import { expandProperty } from "inline-style-expand-shorthand";

export const withoutMarginStyles = expandProperty("margin", 0);
